<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Analiz Sonuçları">
          <!-- <b-alert variant="warning" show class="mb-0">
                  <div class="alert-body mb-2">
                    <span
                      ><strong>Not:</strong> Eklenecek içerik adı ve arama motoru
                      bağlantı linki benzersiz olmalıdır...</span
                    >
                  </div>
                </b-alert> -->
          <!-- <b-button
              class="float-right"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              :to="`/product/create`"
            >
              Yeni Ürün Ekle
            </b-button> -->
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Analiz Sonuçları">
          <b-form>
            <b-row>
              <b-col cols="12" class="mb-2 mt-2">
                <div class="d-flex justify-content-center align-items-center">
                  <b-pagination
                    :value="1"
                    :total-rows="rows"
                    :per-page="12"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="(value) => getAnalysisResults(value)"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4"> </b-col>
              <b-col md="4">
                <div class="mb-2">
                  <b-form-group label="Başlangıç Tarihi" label-for="startDate">
                    <b-form-datepicker
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                      locale="tr"
                      v-model="startDate"
                    />
                  </b-form-group>
                </div>
                <div class="mb-2">
                  <b-form-group label="Bitiş Tarihi" label-for="endDate">
                    <b-form-datepicker
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                      locale="tr"
                      v-model="endDate"
                    />
                  </b-form-group>
                </div>
                <div class="mb-2 d-flex justify-content-center align-items-center">
                  <b-button
                    class="float-right"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success"
                    target="_blank"
                    v-on:click="getAnalysisResults(1)"
                  >
                    Filtrele
                  </b-button>
                </div>
                <div class="mb-2  d-flex justify-content-center align-items-center">
                  <b-button
                    class="float-right"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success"
                    target="_blank"
                    :href="`${baseUrl}/api/v1/dashboard/analysis-result/export/query?startDate=${startDate}&endDate=${endDate}`"
                  >
                    Dışa Aktar
                  </b-button>
                </div>
              </b-col>
              <b-col md="4"> </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div class="d-flex justify-content-center align-items-center">
                  <table class="table b-table table-responsive w-auto">
                    <thead>
                      <th>İŞLEM NUMARASI</th>
                      <th>IATA KODU</th>
                      <th>CİHAZ</th>
                      <th>KULLANICI</th>
                      <th>UYRUK</th>
                      <th>DOĞUM TARİHİ</th>
                      <th>ÜRÜN</th>
                      <th>SKOR</th>
                      <th>YÜZDE</th>
                      <th>OLUŞTURMA TARİHİ</th>
                      <th>İŞLEMLER</th>
                    </thead>
                    <tbody>
                      <tr
                        v-for="analysisResult in analysisResults"
                        :key="analysisResult.id"
                      >
                        <td>{{ analysisResult.id }}</td>
                        <td>{{ analysisResult.iataCode }}</td>
                        <td>{{ analysisResult.deviceName }}</td>
                        <td>{{ analysisResult.userName }}</td>
                        <td>{{ analysisResult.nationality.nationality }}</td>
                        <td>{{ analysisResult.birthday }}</td>
                        <td>{{ analysisResult.products[1].name }}</td>
                        <td>{{ analysisResult.scores[1].totalScore }}</td>
                        <td>{{ analysisResult.scores[1].percentage }}</td>
                        <td>{{ analysisResult.createdAt }}</td>
                        <td>
                          <b-button-group>
                            <b-button
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              variant="outline-warning"
                              class="btn-icon rounded-circle mr-1"
                              :to="`/analysis-result/edit/${analysisResult.id}`"
                            >
                              <feather-icon icon="EditIcon" />
                            </b-button>
                          </b-button-group>
                        </td>
                      </tr>
                    </tbody>
                    <thead>
                      <th>İŞLEM NUMARASI</th>
                      <th>IATA KODU</th>
                      <th>CİHAZ</th>
                      <th>KULLANICI</th>
                      <th>UYRUK</th>
                      <th>DOĞUM TARİHİ</th>
                      <th>ÜRÜN</th>
                      <th>SKOR</th>
                      <th>YÜZDE</th>
                      <th>OLUŞTURMA TARİHİ</th>
                      <th>İŞLEMLER</th>
                    </thead>
                  </table>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="mb-2 mt-2">
                <div class="d-flex justify-content-center align-items-center">
                  <b-pagination
                    :value="1"
                    :total-rows="rows"
                    :per-page="12"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="(value) => getAnalysisResults(value)"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                  <b-button
                    class="float-right mt-2 mr-1"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success"
                    target="_blank"
                    :href="`${baseUrl}/api/v1/dashboard/analysis-result/export/query?startDate=${startDate}&endDate=${endDate}`"
                  >
                    Dışa Aktar
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import settings from "../../../settings";
import Ripple from "vue-ripple-directive";
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BCardText,
  BFormGroup,
  BPagination,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
  BFormDatepicker,
} from "bootstrap-vue";

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BAlert,
    BBadge,
    BButton,
    BAvatar,
    BCardText,
    BFormGroup,
    BPagination,
    BButtonGroup,
    BButtonToolbar,
    BListGroupItem,
    BFormDatepicker,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      rows: 100,
      currentPage: 1,
      analysisResults: [],
      baseUrl: settings.apiBaseUrl,
      startDate: null,
      endDate: null,
      locale: this.$i18n.locale,
    };
  },
  watch: {
    currentPage: {
      handler: function (newVal, oldVal) {
        this.getAnalysisResults(newVal);
      },
      deep: true,
    },
  },
  methods: {
    getAnalysisResults(page) {
      endpoints
        .getAnalysisResults(page ,this.startDate,this.endDate, this.$i18n.locale, () => {})
        .then((data) => {
          this.analysisResults = [...data.response.data];
          this.rows = data.response.meta.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getAnalysisResults(this.currentPage);
  },
};
</script>
